import type { ShowNotification as ShowNotificationOp } from '~/app/_types/chat-script';
import {
  HStack,
  HstackProps,
  Image,
  Paragraph,
  VStack,
} from '@styled-system/jsx';

type Props = {
  op: ShowNotificationOp;
} & HstackProps;

export const ShowNotification = ({ op, ...hstackProps }: Props) => (
  <HStack
    px="10px"
    py="12px"
    borderRadius="8px"
    userSelect="none"
    bgColor="rgba(247, 247, 247, 0.75)"
    boxShadow="0px 2px 10px 0px rgba(0, 0, 0, 0.1), 0px 0px 1px 0px rgba(0, 0, 0, 0.10);"
    gap="10px"
    justifyContent="flex-start"
    alignItems="center"
    w="100%"
    maxW="640px"
    cursor="pointer"
    {...hstackProps}
  >
    <Image
      src={op.image.imageUrl}
      alt={op.title}
      w="32px"
      h="32px"
      borderRadius="4px"
      flexShrink={0}
    />
    <VStack
      gap="2px"
      w="100%"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      <Paragraph fontWeight={600} fontSize="size_12" maxLines="2" lineClamp="2">
        {op.title}
      </Paragraph>
      <Paragraph fontSize="size_10" maxLines="2" lineClamp="2">
        {op.text}
      </Paragraph>
    </VStack>
  </HStack>
);
